import { HomeIcon, InspectIcon, MeasureIcon, UserIcon } from "cssReset/icon";
import { AlramMenuItem, InquiryTypeProps } from "interface/interface.alram";
import { MenuItem } from "interface/interface.mypage";

export const FooterMenu = [
  { path: "/home", title: "홈", icon: HomeIcon },
  { path: "/inspect", title: "검사", icon: InspectIcon },
  { path: "/measure", title: "측정", icon: MeasureIcon },
  { path: "/mypage", title: "MY", icon: UserIcon },
];

export const SettingMenuData: MenuItem[] = [
  { title: "사용자 설정", isTitle: true },
  { title: "계정 및 프로필", isTitle: false, path: "/setting/settingProfile" },
  { title: "차단사용자 관리", isTitle: false, path: "/setting/blockUser" },
  // { title: "프리미엄 측정", isTitle: true },
  // { title: "프리미엄 자세히 알아보기", isTitle: false },
  { title: "기타", isTitle: true },
  { title: "공지사항", isTitle: false, path: "/setting/notice" },
  { title: "1:1 문의", isTitle: false, path: "/setting/inquiry" },
  { title: "이용 약관", isTitle: false, path: "/setting/useTerm" },
  { title: "개인정보 처리방침", isTitle: false, path: "/setting/privacy" },
  { title: "앱 버전 v1.00", isTitle: false },
];

export const AlramSettingMenuData: AlramMenuItem[] = [
  { title: "커뮤니티 알림", isTitle: true, isBtn: false },
  {
    title: "작성한 글/댓글에 달린 댓글/답글 알림",
    isTitle: false,
    isBtn: true,
    checkBoxName: "commentNotify",
  },
  {
    title: "작성한 글에 달린 좋아요 알림",
    isTitle: false,
    isBtn: true,
    checkBoxName: "likeNotify",
  },
  {
    title: "프리미엄 측정 알림",
    isTitle: true,
    isBtn: false,
  },
  {
    title: "이상 소음 발생 시 알림",
    isTitle: false,
    isBtn: true,
    checkBoxName: "abnormalNoiseNotify",
  },
  {
    title: "측정 키트 연결 끊김 및 오류 발생 시 알림",
    isTitle: false,
    isBtn: true,
    checkBoxName: "kitErrorNotify",
  },
  {
    title: "혜택, 이벤트 및 기타 알림",
    isTitle: true,
    isBtn: false,
  },
  {
    title: "RS101 공지사항",
    isTitle: false,
    isBtn: true,
    checkBoxName: "announcementNotify",
  },
  {
    title: "마케팅 수신 동의",
    isTitle: false,
    isBtn: true,
    checkBoxName: "marketingNotify",
  },
];

export const InquiryTypeDt: InquiryTypeProps[] = [
  { id: "USER", name: "회원가입/정보관리" },
  { id: "SERVICE", name: "시스템/서비스 오류" },
  { id: "DEVICE", name: "디바이스" },
  { id: "PAY", name: "결제" },
  { id: "EVENT", name: "이벤트" },
  { id: "ETC", name: "기타" },
];

export const DeleteAccountInfoText = `회원 탈퇴가 완료되면 회원님의 계정과 관련된 모든 정보가 삭제되며 복구가 불가능합니다. 커뮤니티에서 작성한 게시글, 댓글, 좋아요 등의 기록 또한 삭제되며, 다른 회원들에게도 더 이상 표시되지 않습니다.

탈퇴 시 회원님이 진행했던 검사 결과와 분석 내용, 저장된 기록 등이 모두 영구적으로 삭제됩니다. 삭제된 데이터는 다시 복원할 수 없으니, 필요한 경우 탈퇴 전 데이터를 별도로 저장해 두시기 바랍니다.

유료 구독 서비스나 정기 결제 상품을 이용 중이라면, 탈퇴 전에 반드시 구독을 취소해야 합니다. 탈퇴 후에도 구독이 유지될 경우, 추가 결제가 발생할 수 있으니 [결제 관리] 메뉴에서 확인 및 취소를 진행해 주세요.

관계 법령에 따라 일정 기간 동안 일부 정보(결제 기록 등)가 보관될 수 있습니다. 이 정보는 법적 의무 이행을 위해서만 사용되며, 보관 기간이 만료되면 안전하게 파기됩니다.`;

export const AdminMenuDt = [
  { title: "문의 관리", path: "/admin/inquiry" },
  { title: "후기 관리", path: "/admin/review" },
  { title: "회원 관리", path: "/admin/user" },
  {
    title: "콘텐츠 관리",
    subMenu: [
      { title: "메인 배너", path: "/admin/banner" },
      { title: "하단 팝업배너", path: "/admin/footerpopup" },
      { title: "공지사항", path: "/admin/notice" },
      { title: "RS101 칼럼", path: "/admin/column" },
      { title: "캘리브레이션 관리", path: "/admin/calibration" },
    ],
  },
  { title: "대시보드", path: "/admin/dashboard" },
];

// admi dashboard
export const AGE_GROUPS = [
  { label: "10대", key: "teens" },
  { label: "20대", key: "twenties" },
  { label: "30대", key: "thirties" },
  { label: "40대", key: "forties" },
  { label: "50대", key: "fifties" },
  { label: "60대", key: "sixties" },
  { label: "70대", key: "seventies" },
];

export const PIE_COLORS = [
  "#5B93FF",
  "#8BC34A",
  "#FFC107",
  "#E91E63",
  "#00BCD4",
  "#9C27B0",
  "#FF5722",
];

export const SIMPLE_TEST_DATA = [
  {
    question: `영화관에서 소곤대는 소리나 \n비닐봉지 소리가 신경쓰인다`,
    imgPath: "/assets/survey/survey_img_1.png",
  },
  {
    question: `자다가 소음 때문에 \n잠에서 깨곤 한다`,
    imgPath: "/assets/survey/survey_img_2.png",
  },
  {
    question: `주변 소리때문에 \n일에 집중하기 어렵다`,
    imgPath: "/assets/survey/survey_img_3.png",
  },
  {
    question: `이웃이 시끄러우면 \n짜증이 난다`,
    imgPath: "/assets/survey/survey_img_4.png",
  },
  {
    question: `주변 소음을 감소시키기 위해 \n헤드폰이나 귀마개를 착용해 본 적 있다`,
    imgPath: "/assets/survey/survey_img_5.png",
  },
  {
    question: `혼자 있고 싶을 때 \n바깥에서 들려오는 소음이 방해된다`,
    imgPath: "/assets/survey/survey_img_6.png",
  },
  {
    question: `소음이 있는 사회적 활동을 할 때, \n소리 때문에 불편함이 느껴진다\n(술집, 노래방, 콘서트 등)`,
    imgPath: "/assets/survey/survey_img_7.png",
  },
  {
    question: `시끄러운 곳에서는 \n휴식을 취하기 힘들다`,
    imgPath: "/assets/survey/survey_img_8.png",
  },
  {
    question: `내가 자거나 일을 하는데 방해가 \n되는 소음을 내는 사람에게 화가 난다`,
    imgPath: "/assets/survey/survey_img_9.png",
  },
  {
    question: `소음에 대한 불편함 때문에 \n타인의 초대나 약속을 거절하거나 \n취소한 적이 있다`,
    imgPath: "/assets/survey/survey_img_10.png",
  },
];

export const answerOptions = [
  { label: "매우 그렇다", value: 5 },
  { label: "그렇다", value: 4 },
  { label: "그런 편이다", value: 3 },
  { label: "아닌 편이다", value: 2 },
  { label: "아니다", value: 1 },
  { label: "매우 아니다", value: 0 },
];

export const stepIntroData = [
  {
    id: 1,
    title: "나는 소음에 얼마나 민감할까요?",
    description: `총 10개의 질문으로 빠르게 알아봐요! \n\n나와 가장 일치하는 선택지를 골라주세요.\n너무 고민하지 말고, 편안하게 선택해 주세요.`,
    imgPath: "/assets/icon/test_step_one.png",
    extra: null,
  },
  {
    id: 2,
    title: "내 귀는 어떤 소리에 더 예민할까?",
    description: `저주파? 고주파?\n어떤 소리가 나에게 더 잘 들릴까요?\n총 7문항으로 간단하게 검사해 보세요.\n\n휴대폰 기본 스피커로 검사하는 것을 추천합니다.\n이어폰이나 헤드셋을 사용하신다면, 음역대별 보정이 최대한 적은 제품을 사용해주세요.`,
    imgPath: "/assets/icon/test_step_two.png",
    extra: null,
  },
];

export const SIMPLE_TEST_AUDIO_DATA = [
  {
    question: `기준음이 주변 소리와\n명확하게 구분되어 들리도록\n휴대전화 음량을 조정해주세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder2/(2-1)500Hz-51dB.wav",
      "/assets/audio_file/folder2/(2-2)500Hz-48dB.wav",
      "/assets/audio_file/folder2/(2-3)500Hz-45dB.wav",
    ],
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder3/(3-1)250Hz-51dB.wav",
      "/assets/audio_file/folder3/(3-2)250Hz-48dB.wav",
      "/assets/audio_file/folder3/(3-3)250Hz-45dB.wav",
    ],
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder4/(4-1)125Hz-42dB.wav",
      "/assets/audio_file/folder4/(4-2)125Hz-39dB.wav",
      "/assets/audio_file/folder4/(4-3)125Hz-36dB.wav",
    ],
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder5/(5-1)60Hz-33dB.wav",
      "/assets/audio_file/folder5/(5-2)60Hz-30dB.wav",
      "/assets/audio_file/folder5/(5-3)60Hz-27dB.wav",
    ],
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder6/(6-1)1.5kHz-60dB.wav",
      "/assets/audio_file/folder6/(6-2)1.5kHz-57dB.wav",
      "/assets/audio_file/folder6/(6-3)1.5kHz-54dB.wav",
    ],
  },
  {
    question: `기준음과\n[가장 동일한 크기] 로 느껴지는\n소리를 고르세요.`,
    audioPath_default: "/assets/audio_file/folder1/1kHz-54dB.wav",
    audioPath: [
      "/assets/audio_file/folder7/(7-1)2kHz-60dB.wav",
      "/assets/audio_file/folder7/(7-2)2kHz-57dB.wav",
      "/assets/audio_file/folder7/(7-3)2kHz-54dB.wav",
    ],
  },
];

export const INSPECT_RESULT_DATA = [
  {
    id: 1,
    title: "고요한 숲 속의 토끼",
    imgPath: "/assets/survey_result/result1.png",
    description:
      "고요한 숲 속에서 귀를 쫑긋 세우고 있는 토끼처럼, 주변의 아주 작은 소음도 잘 감지하고 반응합니다. 뒷 사람이 책장을 넘기는 소리, 물 마시는 소리, 작은 속삭임까지 포착해 내는 높은 청력 민감도로 인해 소음이 있는 환경에서 집중이 분산되고 쉽게 피로해지는 경향이 있습니다. 또한 갑작스러운 소음으로 인해 깜짝 놀라고 스트레스를 받기 쉽습니다.",
    contents:
      "이 유형은 다른 유형에 비해 작은 소음에도 막대한 고통을 겪을 수 있습니다. 지속적인 소음에 노출될 경우, 일상생활 전반에서의 불안이나 청각과민증이 나타나기도 합니다. 층간소음으로 인해 집에서 편하게 휴식하기 힘들다면, 더 심한 건강 문제로 발전하기 전에 해결이 필요합니다.",
  },
  {
    id: 2,
    title: "평온한 공원의 고양이",
    imgPath: "/assets/survey_result/result2.png",
    description:
      "평온한 공원을 산책하는 고양이처럼, 다양한 소리를 골고루 감지하고 경계합니다. 잔잔한 새소리나 바람결 소리는 배경음으로 흘려보내며, 대화 소리나 주기적인 기계음 등은 ‘이 정도는 괜찮다’ 고 받아들입니다. 그러나 불규칙적인 소리나 갑작스러운 소리에는 민감하게 반응하므로, 스트레스 조절을 위해 백색소음이나 클래식 음악을 활용하기도 합니다.",
    contents:
      "이 유형은 낮은 소음 정도는 큰 타격 없이 흘려버릴 수 있지만, 예민한 청력을 가지고 있기에 불규칙하거나 큰 소음에 자주 노출될 경우 청감이 과민해져 일상에서 불편을 겪게될 수 있습니다. 집 안에서 신경쓰이는 소음이 자주 느껴진다면, 청각과민에 이르기 전 빠른 해결이 필요합니다.",
  },
  {
    id: 3,
    title: "활기찬 호숫가의 거북이",
    imgPath: "/assets/survey_result/result3.png",
    description:
      "활기찬 호숫가를 헤엄치는 거북이처럼, 낮고 꾸준한 소음에는 크게 동요하지 않습니다. 멀리서 들리는 차량 소리, 복도에서 들리는 발소리 등의 소음에는 오히려 심리적 안정을 느끼기도 하며, 갑작스러운 소리에도 다소 늦게 반응하여 ‘무던하다’는 이야기를 듣기도 합니다. 무음 상태보다는 소음이 일정하게 유지되는 환경에서 집중력이 가장 높아집니다.",
    contents:
      "이 유형은 적당한 소음이 있는 환경에서도 집중력이 높고 편안하게 느끼지만, 갑작스럽거나 불규칙적으로 발생하는 실내 층간소음은 지속적인 스트레스를 줄 수 있습니다. 평소와 달리 층간소음이 거슬리게 느껴진다면, 청감이 더 예민해지기 전에 조치를 취하는 것이 좋습니다.",
  },
  {
    id: 4,
    title: "드넓은 초원의 물소",
    imgPath: "/assets/survey_result/result4.png",
    description:
      "드넓은 초원을 유유히 거니는 물소처럼, 복합적인 소음 환경에서도 전혀 동요하지 않습니다. 사람들의 웃음소리, 음악 소리, 동물 울음소리 등 다양한 음파가 뒤섞여도 ‘편안하다’고 느끼며, 주변이 너무 정숙하면 오히려 불안해하기도 합니다. 이들은 폭발음이나 경보음 같은 큰 자극이 들어와야 ‘소리가 크다’ 고 인지할 만큼 청각 자극에 여유롭습니다.",
    contents:
      "이 유형은 왠만한 큰 소음에도 스트레스를 받거나 신경 쓰지 않는 청감의 소유자입니다. 만약 이 유형이 층간소음으로 불편을 겪고 있다면, 소음의 크기나 빈도가 극심할 확률이 높습니다. 실내 소음을 정확히 측정하고 원인을 해결하여 청력 건강에 대한 주의가 필요합니다.",
  },
];

export const INSPECT_RESULT_NOISE_DATA = [
  { id: 1, contents: "저주파 소리를 더 예민하게 감지합니다." },
  { id: 2, contents: "고주파 소리를 더 예민하게 감지합니다." },
  {
    id: 3,
    contents: "저주파 및 고주파 소리 모두를 예민하게 감지합니다.",
  },
  {
    id: 4,
    contents: "전반적으로 모든 주파수의 소리를 평이하게 감지합니다.",
  },
];
